<template>
  <SystemMdmCommandsModal
    :actionEvent="actionEvent"
    :actionText="actionText"
    :enableMainAction="isComplete"
    :executeAction="executeAction"
    :header="header"
  >
    <template v-slot:default>
      <ParagraphBody
        v-for="text in bodyText"
        :key="text"
      >
        <MarkdownInline :mdTemplate="text" />
      </ParagraphBody>
      <div :class="$style.pinCode">
        <PinCode
          @complete="onComplete"
          @incomplete="onIncomplete"
        />
      </div>
    </template>
  </SystemMdmCommandsModal>
</template>

<script>
import { MarkdownInline, ParagraphBody } from '@jumpcloud/ui-components';
import PinCode from 'client/components/FormValidation/PinCode/PinCode.vue';
import SystemMdmCommandsModal from 'client/systems/SystemMdmCommandsModal.vue';

export default {
  name: 'SystemMdmCommandsPinModal',

  components: {
    MarkdownInline,
    ParagraphBody,
    PinCode,
    SystemMdmCommandsModal,
  },

  props: {
    actionEvent: {
      required: true,
      type: String,
    },
    actionText: {
      required: true,
      type: String,
    },
    bodyText: {
      required: true,
      type: Array,
      default: () => [],
    },
    dmId: {
      required: true,
      type: String,
    },
    header: {
      required: true,
      type: String,
    },
    mdmsApiAction: {
      required: true,
      type: Function,
    },
    systemId: {
      required: true,
      type: String,
    },
  },

  data: () => ({
    pin: '',
    isComplete: false,
  }),

  methods: {
    executeAction() {
      return this.mdmsApiAction(this.dmId, this.systemId, { pin: this.pin });
    },

    onComplete(pin) {
      this.isComplete = true;
      this.pin = pin;
    },

    onIncomplete() {
      this.isComplete = false;
    },
  },
};
</script>

<style module>
.pinCode {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}

</style>
